import Icon from '../components/Icon.vue'

Icon.register({"long-arrow-alt-left":{"width":448,"height":512,"paths":[{"d":"M134.1 296H436C442.6 296 448 290.6 448 284V228C448 221.4 442.6 216 436 216H134.1V169.9C134.1 148.6 108.2 137.9 93.1 153L7 239C-2.3 248.4-2.3 263.6 7 273L93.1 359C108.2 374.1 134.1 363.4 134.1 342.1V296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/long-arrow-alt-left.js
// module id = null
// module chunks = 